import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import axios from "axios";
const ViewLead = ({ show, onClose, day, month, year }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const months = [
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];

    useEffect(() => {
        axios.post(`${baseURL}/get_year_leadsource/leads`, {
            day: day,
            month: month,
            year: year,
            branch_id: branch_id
        }).then(response => {
           setData(response.data.data);
           setHasFetched(true);
        })
        .catch(error => {
            console.log('There was an error fetching the data!', error);
            setHasFetched(true);
        });
    }, [day, month, year]);
    
    const tableRef = useRef(null);
    useEffect(() => {
        if(hasFetched){
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "250px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">View Lead Details </h3>
                        <div className="ms-1 me-1 fw-bold text-white">-</div>
                        <Badge bg="none" className='py-1 px-2 fs-4 border border-white shadow-lg text-white'>{day}-{months[month-1]}-{year}</Badge>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                   
                    <div className="table-container"  >
                        <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-100px text-start'>Lead</th>
                                    <th className='min-w-100px'>Lead Source</th>
                                    <th className='min-w-100px text-center'>Sales Person</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">

                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.name}</label>
                                            <div className='d-block'>
                                                <div className='text-dark font-w600 fs-8'>{data.mobile_no}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.lead_source}</div>
                                        </td>
                                        <td className='text-center'>
                                            <label className='text-black font-w400 fs-7'>{data.sales_person}</label>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </Modal>
    );
};

export default ViewLead;
